module.exports = __webpack_public_path__ + "img/logoRust.3e58ad2a.svg";